import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { getForgeToken, isForgeConfigured } from '../../config'
import { ArtifactSummary } from '../../forgeApi.types'
import { GetArtifactsParams, GetArtifactsResponse } from './getArtifacts.types'

export const getArtifacts = async (
  params?: GetArtifactsParams
): Promise<ArtifactSummary[]> => {
  const response = await forgeApi.get<GetArtifactsResponse>(
    '/api/v1/artifacts',
    params ? { params } : undefined
  )
  return response.data.artifacts ?? []
}

export const GET_ARTIFACTS_QUERY_KEY = 'ai-agent-artifacts'

export const useGetArtifactsQuery = (
  options?: ExtendableQueryOptions<ArtifactSummary[]>,
  params?: GetArtifactsParams
) => {
  const enabled = isForgeConfigured() && Boolean(getForgeToken())
  return useQuery({
    queryKey: params
      ? [GET_ARTIFACTS_QUERY_KEY, params]
      : [GET_ARTIFACTS_QUERY_KEY],
    queryFn: () => getArtifacts(params),
    enabled,
    ...options
  })
}
